import { useEffect, useState } from "react";
import api from "@/lib/api";

// Haptics — feature-detected, no-op (never throws) on iOS Safari / unsupported devices.
// Visual flash + audio beep are the PRIMARY signal; vibration is a bonus where available.
export function haptic(pattern) {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(pattern);
    }
  } catch { /* silently ignore — never let haptics break a floor action */ }
}
export const HAPTIC = { success: 50, error: [100, 50, 100] };

// Recent scans — pure UI convenience for rapid back-and-forth on the floor. Kept in
// localStorage ON PURPOSE (unlike the surface PREFERENCE, which is server-side per user):
// a recent-scan list is device-local and disposable, not an account setting.
const RECENT_KEY = "floor_recent_scans";
export function getRecent() {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch { return []; }
}
export function pushRecent(item) {
  const list = getRecent().filter((x) => !(x.kind === item.kind && x.id === item.id));
  list.unshift({ kind: item.kind, id: item.id, label: item.label, url: item.url, ts: Date.now() });
  const trimmed = list.slice(0, 5);
  try { localStorage.setItem(RECENT_KEY, JSON.stringify(trimmed)); } catch { /* ignore */ }
  return trimmed;
}

// Owner-editable floor button set for a given card surface ('part' | 'truck'). Only
// ENABLED actions, already ordered by the owner (backend sort).
export function useFloorActions(surface) {
  const [actions, setActions] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/floor-actions", { params: { surface, include_disabled: false } })
      .then(({ data }) => { if (alive) setActions(data.items || []); })
      .catch(() => { if (alive) setActions([]); });
    return () => { alive = false; };
  }, [surface]);
  return actions;
}
